import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import './VerificacionMailPage.scss';
import { CircularProgress } from '@mui/material';
import { Bounce, ToastContainer, toast } from 'react-toastify';

import { verifyUser } from '../../data/api'; // Importa la función para verificar al usuario desde el API

const VerificacionMailPage = ({  }) => {
    const { userId } = useParams();
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    useEffect(() => {

        const fetchRequest = async () => {
            if (userId) {
                const resp = await verifyUser(userId); // Realiza la solicitud para verificar al usuario
                setLoading(false); // Indica que la solicitud ha finalizado

                if (resp.status === 'success') {
                    // Verificación exitosa
                    setSuccess(true)
                    toast.success('Verificación exitosa', {
                        position: 'bottom-right',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: 'dark',
                        transition: Bounce,
                    });
                } else {
                    // Verificación fallida
                    setSuccess(false)
                    toast.error(resp.error, {
                        position: 'bottom-right',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: 'dark',
                        transition: Bounce,
                    });
                }
            }
        };

        fetchRequest();
    }, []);

    return (
        <div className="verificacion-mail-page">
            <div className="verificacion-mail-container">
                {loading ? (
                    // Muestra el Progress circular mientras se hace la solicitud
                    <CircularProgress size={80} color="secondary" />
                ) : (
                    success ? (
                        <>
                            <h2>Verificación exitosa</h2>
                            <p>Tu correo electrónico ha sido verificado correctamente.</p>
                            <p>Ahora puedes iniciar sesión.</p>
                            <NavLink to="/" className="login-button">
                                Iniciar sesión
                            </NavLink>
                        </>
                    ) : (
                        <>
                            <h2>Verificación fallida</h2>
                            <p>Hubo un error</p>
                        </>
                    )
                    
                )}
            </div>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
                transition={Bounce}
            />
        </div>
    );
};

export default VerificacionMailPage;
